'use strict';

var domCache = require('dom-cache');

var blockClass = 'scroll-blocker';

var isBlocked = false;

var block = function() {

	var scrollY;

	if (isBlocked) {

		return;

	}

	// Store the scroll position before setting the body to fixed position.
	scrollY = window.pageYOffset;

	domCache.body
		.addClass(blockClass)
		// Position the now fixed body to mimick where it was scrolled to.
		.css('top', -scrollY);

	isBlocked = true;

};

var unblock = function() {

	var scrollY;

	if (!isBlocked) {

		return;

	}

	// Note: Using domCache.body.css('top') instead of style.top on the native node caused cross browser issues on certain mobile devices
	scrollY = Math.abs(parseInt(domCache.body[0].style.top, 10));

	domCache.body.removeClass(blockClass);

	// Restore the scroll position to where it was before.
	window.scrollTo(0, scrollY);

	domCache.body.css('top', 'auto');

	isBlocked = false;

};

domCache.window.on('load', function() {

	domCache.head.append('<style id="scrollBlocker">.scroll-blocker{position:fixed;}</style>');

});

module.exports = {

	block: block,
	unblock: unblock

};
